import { FC } from "preact/compat";
import { SingleWidgetProps } from "../interfaces";
import Breakdown from "./Breakdown";

const FeeCode: FC<SingleWidgetProps> = ({ id, className }) => (
    <Breakdown id={id} by="feecode" className={className} />
);

export default FeeCode;
